import { useRunxRadarRedirectAdapter } from "adapters/runxRadarRedirect";
import { IFrame } from "components/atoms/IFrame";

const RunxRadarRedirectIFrame = () => {
  const { basePath, ref, src, title } = useRunxRadarRedirectAdapter();

  return <IFrame basePath={basePath} ref={ref} title={title} src={src} />;
};

export { RunxRadarRedirectIFrame };
